import sendToDataLayer from "./destinations/sendToDataLayer";
import sendToFullstory from "./destinations/sendToFullstory";
import sendToMetaPixel from "./destinations/sendToMetaPixel";
import type {
  TrackingEventName,
  TrackingEvents,
  TrackingProperties,
} from "./types";

// Properties can be left out only when none of the event's are required.
type TrackArgs<E extends TrackingEventName> =
  Partial<TrackingEvents[E]> extends TrackingEvents[E]
    ? [properties?: TrackingEvents[E]]
    : [properties: TrackingEvents[E]];

// Sends one event to every configured destination. Add a destination here,
// not at the call sites. Every destination gets the same payload, so a
// property has one name everywhere; each destination decides which events it
// handles, and one that isn't loaded on the page skips silently.
const track = <E extends TrackingEventName>(
  event: E,
  ...[properties]: TrackArgs<E>
) => {
  if (typeof window === "undefined") {
    return;
  }
  const payload: TrackingProperties = { ...properties };
  sendToDataLayer(event, payload);
  sendToFullstory(event, payload);
  sendToMetaPixel(event, payload);
};

export default track;
